import type { GameTypeName } from '../types/Game';
import { GameType } from '../types/Game';

export const getPromoGameName = (gameType: GameTypeName, promoRef: string) => {
  switch (true) {
    case /PM250M/i.test(promoRef):
      return 'High Roller';
    case /1M2020/i.test(promoRef) && gameType === GameType.HoldemFlash:
      return 'Flash 1Million special';
    case /1M2020/i.test(promoRef):
      return '$1 Million';
    case /pca/i.test(promoRef):
      return 'pca';
    case /ukFree/i.test(promoRef):
      return 'play for free uk';
    case /pspc/i.test(promoRef):
      return 'pspc';
    case /sundayM/i.test(promoRef):
      return 'sunday Million';
    case /wcoop/i.test(promoRef):
      return 'wcoop';
    default:
      return '';
  }
};
